// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import global from './assets/js/global';
import { 
  addGtmScript
} from "./assets/js/gtm"; 
import tools from './assets/js/tools';
import richmarker from '../static/js/richmarker';
import constant from './constant'
import VueMeta from 'vue-meta'
// import jquery from 'jquery'
import BootstrapVue from 'bootstrap-vue'
// axios
import axios from 'axios'
window.axios = require('axios');
// Require dependencies
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
//引入ＧＴＭ
addGtmScript()
// 引入全域ＪＳ
Vue.use(global)
Vue.use(tools)
Vue.use(VueMeta)
Vue.use(richmarker)
Vue.use(BootstrapVue)
Vue.use(VueCookie);
// smooth scroll
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)
// firebase
import VueFire from 'vuefire'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/analytics";
Vue.use(firestorePlugin)
// db
firebase.initializeApp(constant.firebaseConfig)
var firebaseBiz = firebase.initializeApp(constant.firebaseBizConfig, "BUSSINESS")
var firebaseTenant = firebase.initializeApp(constant.firebaseTenantConfig, "TENANT")
Vue.prototype.$analytics = firebase.analytics();

Vue.prototype.$analyticsBiz = firebaseBiz.analytics();
Vue.prototype.$analyticsTenant = firebaseTenant.analytics();
Vue.prototype.$firebaseStore = firebaseBiz.firestore();
export const db = firebase.firestore();

//hightLight
import TextHighlight from 'vue-text-highlight';
Vue.component('text-highlight', TextHighlight);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js